'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');
var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');
var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
var _inherits2 = require('babel-runtime/helpers/inherits');
var _inherits3 = _interopRequireDefault(_inherits2);
var _ExtensibleError2 = require('./ExtensibleError');
var _ExtensibleError3 = _interopRequireDefault(_ExtensibleError2);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var ParameterError = function (_ExtensibleError) {
  (0, _inherits3.default)(ParameterError, _ExtensibleError);

  /**
   * Creates new instance of ParameterError type.
   * @param  {String} parameterName           Name of the parameter that caused an error.
   * @param  {String} parameterValue          Incorrect value provided by the user.
   * @param  {String} correctValue            Description of the correct value.
   * @param  {String} [userMessage=undefined] User provided error message, allows overriding the default value.
   */
  function ParameterError(parameterName, parameterValue, correctValue) {
    var userMessage = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : undefined;
    (0, _classCallCheck3.default)(this, ParameterError);
    var message = userMessage ? userMessage : 'Parameter ' + parameterName + ' provided incorrect value "' + parameterValue + '". Correct value should be ' + correctValue;
    var _this = (0, _possibleConstructorReturn3.default)(this, (ParameterError.__proto__ || Object.getPrototypeOf(ParameterError)).call(this, message));
    _this.message = message;
    _this.parameterName = parameterName;
    _this.parameterValue = parameterValue;
    _this.correctValue = correctValue;
    return _this;
  }
  return ParameterError;
}(_ExtensibleError3.default);
exports.default = ParameterError;